import { foundationProgressRingShadowOptions, ProgressRing as FoundationProgressRing, } from '@genesislcap/foundation-ui';
import { PrimaryRapidColorHEX } from '../_common/colors.hex';
import { zeroProgressRingStyles as styles } from './progress-ring.styles';
import { zeroProgressRingTemplate as template } from './progress-ring.template';
/**
 * @tagname %%prefix%%-progress-ring
 */
export class ProgressRing extends FoundationProgressRing {
}
export const defaultZeroProgressRingConfig = {
    indeterminateIndicator: `
  <svg class="progress" part="progress" viewBox="0 0 16 16">
    <defs>
      <linearGradient id="linear">
        <stop offset="0%"   stop-color="${PrimaryRapidColorHEX.purple}"/>
        <stop offset="100%" stop-color="${PrimaryRapidColorHEX.blue}"/>
      </linearGradient>
    </defs>
    <circle class="background" part="background" cx="8px" cy="8px" r="7px"></circle>
    <circle class="indeterminate-indicator-1" part="indeterminate-indicator-1" cx="8px" cy="8px" r="7px"></circle>
  </svg>
  `,
};
export const zeroProgressRing = ProgressRing.compose(Object.assign({ baseName: 'progress-ring', template,
    styles, shadowOptions: foundationProgressRingShadowOptions }, defaultZeroProgressRingConfig));
